import React, { Component } from "react";
import styles from "./reportTable.module.scss";

import { v4 as uuidv4 } from "uuid";

class ReportTableUnitInfo extends Component {
  getSettingItem(item) {
    return (
      <div key={uuidv4()}>
        <b>{item.title}</b>: <span>{item.value}</span>
      </div>
    );
  }

  render() {
    const { info } = this.props;

    if (!info) {
      return null;
    }

    return (
      <div className={styles.reportUnitInfoContainer} kye={uuidv4()}>
        {info.settings.map((item) => {
          return this.getSettingItem(item);
        })}
        <div style={{ display: "flex" }}>
          <b>Водитель (-и): </b>{" "}
          {info.drivers.map((item, index) => {
            return (
              <span key={index} style={{ marginRight: "5px" }}>
                {item.title},
              </span>
            );
          })}
        </div>
      </div>
    );
  }
}

export default ReportTableUnitInfo;
